export default __webpack_public_path__ + "static/media/Groupe 9100.89bb92bb.svg";